import "./index.css";
import "./globalStyles.css";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
export * from "./interfaces/config";
export * from "./components/ArcGISMap/ArcGISMap";

export { HeaderSearch } from "./components/HeaderSearch/HeaderSearch";
export { MiniToolbar } from "./components/Toolbar/MiniToolbar";
export { Toolbar } from "./components/Toolbar/Toolbar";
export { BaseModal } from "./components/Modals/BaseModal";
export { BaseDraggable } from "./components/Draggables/BaseDraggable";
export { ScaleTypeDropdown } from "./components/ScaleTypeDropdown";
export { ScaleSettings } from "./components/ScaleSettings";
export { BasemapToggle } from "./components/BasemapToggle";
export { CustomTable } from "./components/DataGrid/GridComponents/CustomTable";

export { IndeterminateCheckbox } from "./components/DataGrid/GridComponents/IndeterminateCheckbox";
export { AdminPage } from "./pages/Admin";
export { LoginPage } from "./pages/Login";
export { ResetPasswordPage } from "./pages/ResetPassword";
export { ForgotPasswordPage } from "./pages/ForgotPassword";
export { PrivateRoutes } from "./pages/helpers/PrivateRoutes";
export { useStore } from "./stores/store";
import ReactSelect from "react-select";
export { ReactSelect };
import esriConfig from "@arcgis/core/config";
export { esriConfig };
export { downloadResponse } from "./utils/fileHelper";
// const mchenryServiceCoreUrl = "https://localhost:7094";
const mchenryServiceCoreUrl = "https://www.mchenrycountygis.org/McHenryServiceCore";
// const mchenryServiceCoreUrl = "https://mcgcgisdev2016.co.mchenry.il.us/McHenryServiceCore";
export { mchenryServiceCoreUrl };

export { addProxyRule } from "@arcgis/core/core/urlUtils";
export { FeatureLayer };

import townshipExtents from "./utils/townshipExtents";
export { townshipExtents };
